import { useVibration } from '@st/use/composables'
import { useFavoriteGamesStore } from '../stores/useFavoriteGamesStore'

export function useFavoriteGame(gameId: number | Ref<number> | (() => number)) {
  const id = computed(() => toValue(gameId))
  const favvoriteStore = useFavoriteGamesStore()
  const { addFavoriteGame, deleteFavoriteGame, checkGameFavorite } =
    favvoriteStore
  const { favoriteStoreLoadingStatus } = storeToRefs(favvoriteStore)

  const vibrate = useVibration()

  const isFavoriteGame = computed(
    () =>
      favoriteStoreLoadingStatus.value === 'success' &&
      checkGameFavorite(id.value),
  )

  function handleFavoriteClick() {
    vibrate()
    return isFavoriteGame.value
      ? deleteFavoriteGame(id.value)
      : addFavoriteGame(id.value)
  }

  return {
    handleFavoriteClick,
    isFavoriteGame,
    favoriteStoreLoadingStatus,
  }
}
